import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';

@Injectable({
  providedIn: 'root',
})
export class OauthService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  GetCode(
    client_id: string,
    redirect_uri: string,
    state: string,
    scope: string
  ): Observable<string> {
    return this.http.get<string>(
      this.globals.apiRoot +
        '/oauth/v1/code?client_id=' +
        client_id +
        '&redirect_uri=' +
        redirect_uri +
        '&state=' +
        state +
        '&scope=' +
        scope +
        '&response_type=code'
    );
  }
}
